var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-table-simple",
    { attrs: { small: true, "sticky-header": "" } },
    [
      _c(
        "b-thead",
        [
          _vm.items.type != "ACCESS_REQUEST"
            ? _c(
                "b-tr",
                [
                  _c(
                    "b-th",
                    {
                      staticStyle: {
                        "text-align": "left",
                        "vertical-align": "middle",
                        width: "36%",
                      },
                    },
                    [_vm._v("Field")]
                  ),
                  _c(
                    "b-th",
                    {
                      staticStyle: {
                        "text-align": "left",
                        "vertical-align": "middle",
                        width: "32%",
                      },
                    },
                    [_vm._v("Old")]
                  ),
                  _c(
                    "b-th",
                    {
                      staticStyle: {
                        "text-align": "left",
                        "vertical-align": "middle",
                        width: "32%",
                      },
                    },
                    [_vm._v("New ")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.items.type && _vm.items.type == "ACCESS_REQUEST"
            ? _c(
                "b-tr",
                [
                  _c(
                    "b-th",
                    {
                      staticStyle: {
                        "text-align": "left",
                        "vertical-align": "middle",
                        width: "50%",
                      },
                    },
                    [_vm._v("Applicant")]
                  ),
                  _c(
                    "b-th",
                    {
                      staticStyle: {
                        "text-align": "left",
                        "vertical-align": "middle",
                        width: "50%",
                      },
                    },
                    [_vm._v("Benefited")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "b-tbody",
        [
          _vm._l(_vm.items.new, function (ds, index) {
            return index != "update_date" && _vm.items.type != "ACCESS_REQUEST"
              ? _c(
                  "b-tr",
                  [
                    _c("b-td", [_vm._v(_vm._s(index))]),
                    _c("b-td", [_vm._v(_vm._s(_vm.items.old[index]))]),
                    _c("b-td", [_vm._v(_vm._s(_vm.items.new[index]))]),
                  ],
                  1
                )
              : _vm._e()
          }),
          _vm.items.type && _vm.items.type == "ACCESS_REQUEST"
            ? _c(
                "b-tr",
                [
                  _c("b-td", [_vm._v(_vm._s(_vm.items.applicant))]),
                  _c("b-td", [_vm._v(_vm._s(_vm.items.benefited))]),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }